export const constHttpCanceledToken = '__canceled__';
